import React, { useEffect, useState } from 'react';
import { keys, values, assign } from 'lodash';
import { debounce } from 'lodash/fp';
import request from 'utils/request_ajax';
import QuestionPrompt from 'components/Practice/Learner/QuestionPrompt';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import HighFiveShareableLink from 'components/shared/HighFiveShareableLink';
import ReplyContainer from '../Practice/Learner/ReplyContainer';
import QuestionField from './QuestionField';

const TicketHandlingPracticeQuestion = props => {
  const { data, meta, i18n } = props;
  const [message, setMessage] = useState(data?.givenAnswer?.message);
  const [questionFieldData, setQuestionFieldData] = useState(
    data.questionFields,
  );
  const isDisabled = meta.finished || meta.previewing;

  /*
   * Finds the existing answer key in the state's questionFieldData and updates it
   * with the incoming answer data
   * @param  {Object} the incoming answer key and value to be updated
   * @return {Array}  the updated QuestionFieldData
   */
  const updateQuestionFieldData = answer => {
    const answerKey = keys(answer)[0];

    questionFieldData.map((questionField, index) => {
      if (keys(questionField)[0] === answerKey) {
        const updatedArray = [
          ...questionFieldData.slice(0, index),
          answer,
          ...questionFieldData.slice(index + 1),
        ];

        setQuestionFieldData(updatedArray);
      }
      return questionFieldData;
    });
  };

  /*
   * Formats the message and QuestionFieldData in prep for the backend
   * @return {String}  a string of key/value pairs including the message and every question field
   * with it's corresponding answer
   */
  const formatData = () => {
    const messageData = { message };
    const modifiedQuestionFieldData = assign({}, ...questionFieldData);
    return JSON.stringify({ ...modifiedQuestionFieldData, ...messageData });
  };

  const saveAnswer = debounce(300, () => {
    const answerData = {
      answer: formatData(),
      question_id: data.questionId,
    };
    request.postJSON(meta.saveUrl, answerData);
  });

  useEffect(saveAnswer, [saveAnswer, message, questionFieldData]);

  return (
    <div className="bdrs-base PracticeQuestion">
      <QuestionElementPrompt
        required={data.required}
        subject={data.subject}
        questionSubjectClass={meta.questionSubjectClass}
        labelErrorClass={meta.labelErrorClass}
        isGradable={data.isGradable}
        elementHeaderClass={meta.elementHeaderClass}
        isPractice={data.isPractice}
      />
      {meta.features.practice && data.criteria.length > 0 && (
        <QuestionPrompt criteria={data.criteria} features={meta.features} />
      )}
      <div className="p-32 pt-16">
        <ReplyContainer
          previewing={meta.previewing}
          message={message}
          questionType={data.questionType}
          questionTicketHandlingData={data.questionTicketHandlingData}
          isDisabled={isDisabled}
          i18n={i18n.ticket_handling}
          headerText={i18n.ticket_handling.header_text}
          placeholder={i18n.ticket_handling.reply_to}
          updateMessage={debounce(300, setMessage)}
        />
        {data.questionFields && (
          <div className="PracticeQuestion-fields d-f fw-w">
            {data.questionFields.map(questionField => (
              <QuestionField
                key={keys(questionField)[0]}
                title={keys(questionField)[0]}
                userInput={values(questionField)[0]}
                updateQuestionFieldData={debounce(300, updateQuestionFieldData)}
                isDisabled={isDisabled}
                previewing={meta.previewing}
              />
            ))}
          </div>
        )}
        <HighFiveShareableLink
          questionId={data.questionId}
          progressId={data.progressId}
          hasAnswerBeenSubmitted={!!message}
          isGradable={data.isGradable}
        />
      </div>
    </div>
  );
};

export default TicketHandlingPracticeQuestion;
